<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import {
    getCharacterImagePath,
    getTranslatedCharacterName,
  } from '$lib/er/character/translations';
  import { Unlock, UserIcon } from 'lucide-svelte';
  import type { CharacterImageType } from './consts';
  import { freeCharacters } from './stores';

  export let id: number;
  export let type: CharacterImageType;
  export let skinIndex: number;
  export let round = false;
  export let showRotation = false;
  export let random = false;

  $: rotation = $freeCharacters.includes(id);
</script>

<div class="character-icon">
  <div class="image-container" class:random>
    {#if random}
      <span><UserIcon /></span>
    {:else}
      <img
        alt={getTranslatedCharacterName($LL, id)}
        src={getCharacterImagePath(id, type, skinIndex)}
        class:round
      />
    {/if}
  </div>
  {#if $$slots.level}
    <div class="attachment level">
      <slot name="level" />
    </div>
  {/if}
  {#if $$slots.weapon}
    <div class="attachment weapon">
      <slot name="weapon" />
    </div>
  {/if}
  {#if showRotation && rotation}
    <div class="attachment rotation">
      <Unlock size="10" />
    </div>
  {/if}
</div>

<style lang="postcss">
  .character-icon {
    width: fit-content;
    position: relative;

    .attachment {
      position: absolute;
      border-radius: var(--radius-1);
      padding: 1px var(--space-1);
    }

    .level {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--mauve-12);
      border-radius: var(--radius-full);
      font-size: var(--size-4);
      color: var(--mauve-1);
      left: -4px;
      bottom: -4px;
      width: 2rem;
      height: 2rem;
    }

    .rotation {
      background-color: var(--blue-8);
      color: white;
      top: -4px;
      right: -4px;
    }

    .weapon {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: black;
      color: white;
      bottom: -4px;
      right: -8px;
      width: 2rem;
      height: 2rem;
      padding: 0.4rem;
    }
  }

  .image-container {
    width: 5rem;
    height: 5rem;
    overflow: hidden;
    border-radius: var(--radius-2);
    background-color: var(--mauve-3);
  }
  .image-container.random {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: var(--size-7);
    }
  }

  img {
    object-fit: contain;
  }
  img.round {
    border-radius: var(--radius-3);
    background: var(--background);
  }
</style>
